var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "t-panel-section"
  }, [_vm.searching ? _c('p', {
    staticClass: "t-search-message"
  }, [_vm._v("Searching...")]) : _c('p', {
    staticClass: "t-search-message"
  }, [_vm._v(" Found " + _vm._s(_vm.size) + " result"), _vm.size !== 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" for ‘" + _vm._s(_vm.terms) + "’ ")])]), _vm.pageNumResult ? [_c('div', {
    staticClass: "t-panel-section"
  }, [_c('div', {
    staticClass: "t-panel-subheading"
  }, [_vm._v("Page Number")]), _c('AppLink', {
    staticClass: "t-result-pagenum",
    attrs: {
      "pageNum": _vm.pageNumResult.physical
    }
  }, [_vm._v(" Go to page " + _vm._s(_vm.pageNumResult.logical) + " ")])], 1)] : _vm._e(), _vm.results.length ? [_c('div', {
    staticClass: "t-panel-subheading"
  }, [_vm._v("Search Results")]), _c('ul', {
    staticClass: "t-panel-list"
  }, _vm._l(_vm.results, function (r, i) {
    return _c('li', {
      key: i,
      staticClass: "t-panel-item"
    }, [_c('AppLink', {
      staticClass: "t-result-content",
      attrs: {
        "pageNum": r.pageNum,
        "highlightText": _vm.terms
      }
    }, [_c('div', {
      staticClass: "t-result-text"
    }, [_vm._l(_vm.titles[r.pageNum], function (title, i) {
      return _c('div', {
        key: i,
        staticClass: "t-result-title"
      }, [_vm._v(" " + _vm._s(title) + " ")]);
    }), _c('span', {
      staticClass: "t-result-snippet",
      domProps: {
        "innerHTML": _vm._s(r.snippetHtml)
      }
    })], 2), _c('span', {
      staticClass: "t-result-logical-pageno"
    }, [_vm._v(_vm._s(r.logicalPageNum))])])], 1);
  }), 0)] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }